import React, { useState, useEffect } from "react";
import { fetchData } from '../utils/apiUtils';
import { Alert, Spinner } from "react-bootstrap";
import Layout from "../components/Layout";
import { useLang } from "../utils/LangContext";
import PublicGamesList from "../components/PublicGamesList";

const PublicGames = () => {
    
    const { t } = useLang();

    const [publicGames, setPublicGames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadPublicGames = async () => {
            try {
                const data = await fetchData("/api/v1/game/public-games"); // Replace with your API endpoint
                setPublicGames(data || []);
            } catch (err) {
                setError("Failed to load public games. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        loadPublicGames();
    }, []);

    const handleJoinPublicGame = (publicGame) => {
        console.log("Joining public games:", publicGame.name);
        // Add logic to join the event, e.g., API call or navigation
        alert(`You joined the public game: ${publicGame.name}`);
    };

    return (
        <Layout>
        <div className="public-game-view">
            {loading && (
                <div className="loading-spinner">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            )}
            {error && (
                <Alert variant="danger">{error}</Alert>
            )}
            <PublicGamesList publicGames={publicGames} onJoinPublicGame={handleJoinPublicGame} />

        </div>
        </Layout>
    );
};

export default PublicGames;
